import { render, staticRenderFns } from "./limitSets.vue?vue&type=template&id=573c9a3a&scoped=true&"
import script from "./limitSets.vue?vue&type=script&lang=js&"
export * from "./limitSets.vue?vue&type=script&lang=js&"
import style0 from "./limitSets.vue?vue&type=style&index=0&id=573c9a3a&lang=less&scoped=true&"
import style1 from "./limitSets.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c9a3a",
  null
  
)

component.options.__file = "limitSets.vue"
export default component.exports